import { useEffect, useState } from 'react';

import set from 'lodash/set';
import { DefaultValues, useForm, UseFormReturn } from 'react-hook-form';

export const enum FilterIdTypes {
  Id = 'id',
  Merchant = 'merchantReference',
  Provider = 'providerReferenceId',
  Any = 'anyId',
}

export interface FilterIdsValues {
  merchantReference: string[];
  id: string[];
  providerReferenceId: string[];
  anyId?: string[];
}

export type UseIdFiltersReturnValues = {
  onReset: (currentIdFilter: FilterIdTypes) => void;
  onSubmit: (values: FilterIdsValues) => void;
  appliedIdFilters: FilterIdsValues;
  form: UseFormReturn<FilterIdsValues, any, any>;
  setAppliedFilter: (name: string, value: any) => void;
};

type Props = {
  defaultValues: FilterIdsValues;
  resetValues?: DefaultValues<FilterIdsValues>;
};

export function useIdFilters({ defaultValues, resetValues }: Props): UseIdFiltersReturnValues {
  const form = useForm<FilterIdsValues>({
    defaultValues: defaultValues,
  });

  const [appliedIdFilters, setAppliedIdFilters] = useState<FilterIdsValues>(defaultValues);

  useEffect(() => {
    form.reset(defaultValues);
    setAppliedIdFilters(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(defaultValues)]);

  const onReset = (currentIdFilter: FilterIdTypes) => {
    form.reset(resetValues || defaultValues || {});
    setAppliedIdFilters((prev) => ({
      ...prev,
      [currentIdFilter]: [],
    }));
  };

  const setAppliedFilter = (name: string, value: any) => {
    setAppliedIdFilters((prev) => {
      return { ...(set(prev, name, value) as FilterIdsValues) };
    });
  };

  const onSubmit = (values: FilterIdsValues) => {
    setAppliedIdFilters((prev) => ({ ...prev, ...values }) as FilterIdsValues);
  };

  return {
    appliedIdFilters,
    onReset,
    onSubmit,
    setAppliedFilter,
    form,
  };
}
